export default __webpack_public_path__ + "static/media/sw.2474f872.png";